export default __webpack_public_path__ + "3c52a147bf0484652486549ab696c00e.svg";